/*
  EQUIPOS POR DEPORTE  ·  DAR, 5-oct-2026

  Lo usan el armador de packs de la ficha y el explorador de "Entra por tu
  equipo" del inicio. Pide la seccion cj-datos-equipos de una coleccion
  (todas sus paginas), junta las etiquetas de un mismo club y cuenta sus
  productos.

    CJEquipos.cargar('🏈-nfl').then(function (d) {
      d.equipos    -> [{ n, e, hs, c, prods }]  ordenados por cuantos hay
      d.jugadores  -> igual, para los nombres de jugador
      d.productos  -> todos los de la coleccion, en su orden
    });

  Se guarda en memoria y en sessionStorage (15 min): abrir el armador dos
  veces, o pasar de la ficha al inicio, no vuelve a pedir lo mismo.
*/
(function () {
  if (window.CJEquipos) return;

  var RAIZ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var TEMA = (window.Shopify && Shopify.theme && Shopify.theme.id) || '';
  var VIDA = 15 * 60 * 1000;
  var memoria = {};

  /* Dos etiquetas con nombre distinto para el mismo club, mismo escudo. */
  var ALIAS = { 'Rayados': 'Monterrey' };

  function pedir(handle, pagina) {
    var url = RAIZ + 'collections/' + encodeURIComponent(handle) + '?section_id=cj-datos-equipos&page=' + pagina;
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var s = doc.querySelector('[data-cj-datos]');
        if (!s) throw new Error('Sin datos en ' + url);
        return JSON.parse(s.textContent);
      });
  }

  function leerGuardado(clave) {
    try {
      var x = JSON.parse(sessionStorage.getItem(clave) || 'null');
      if (x && Date.now() - x.t < VIDA) return x.v;
    } catch (e) {}
    return null;
  }
  function guardar(clave, v) {
    try { sessionStorage.setItem(clave, JSON.stringify({ t: Date.now(), v: v })); } catch (e) {}
  }

  function armar(crudo) {
    var porClave = {}, equipos = [], jugadores = [], porHandle = {};

    crudo.equipos.forEach(function (e) {
      var n = ALIAS[e.n] || e.n;
      var clave = (e.j ? 'j|' : 'e|') + n;
      var x = porClave[clave];
      if (!x) {
        x = porClave[clave] = { n: n, e: e.e, hs: [], c: 0, j: e.j, prods: [] };
        (e.j ? jugadores : equipos).push(x);
      }
      if (!x.e && e.e) x.e = e.e;
      x.hs.push(e.h);
      (porHandle[e.h] = porHandle[e.h] || []).push(x);
    });

    crudo.productos.forEach(function (p) {
      var vistos = [];
      (p.g || '').split(',').forEach(function (h) {
        (porHandle[h] || []).forEach(function (x) {
          if (vistos.indexOf(x) > -1) return;
          vistos.push(x);
          x.prods.push(p);
        });
      });
    });

    function ordenar(lista) {
      return lista
        .filter(function (x) { x.c = x.prods.length; return x.c > 0; })
        .sort(function (a, b) { return b.c - a.c || a.n.localeCompare(b.n, 'es'); });
    }

    return {
      col: crudo.col,
      titulo: crudo.titulo,
      productos: crudo.productos,
      equipos: ordenar(equipos),
      jugadores: ordenar(jugadores)
    };
  }

  function cargar(handle) {
    if (memoria[handle]) return memoria[handle];
    var clave = 'cjeq:' + TEMA + ':' + handle;
    var guardado = leerGuardado(clave);
    var p = guardado
      ? Promise.resolve(guardado)
      : pedir(handle, 1).then(function (d1) {
          var resto = [];
          for (var i = 2; i <= d1.paginas; i++) resto.push(pedir(handle, i));
          return Promise.all(resto).then(function (ds) {
            var crudo = { col: d1.col, titulo: d1.titulo, equipos: d1.equipos, productos: d1.productos };
            ds.forEach(function (d) { crudo.productos = crudo.productos.concat(d.productos); });
            guardar(clave, crudo);
            return crudo;
          });
        });
    memoria[handle] = p.then(armar);
    memoria[handle].catch(function () { delete memoria[handle]; });
    return memoria[handle];
  }

  window.CJEquipos = { cargar: cargar };
})();
